// extracted by mini-css-extract-plugin
export default {"image":"inspiration_image__q8RLD"};